import React, { useEffect, useState } from "react";
import styled from "styled-components";
import SubcategoryTitleWrapper from "../../components/configurationComponents/SubcategoryTitleWrapper";
import { lightThemeColors } from "../../assets/styles/colors";
import InputFieldWithValidation from "../../components/Generic/InputFieldWithValidation";
import { ReactComponent as ComputerIcon } from "../../assets/icons/generic/BehaviourIcon.svg";
import { isCustomUrlValid } from "../../helper/ValidatorsHelper";

const LinkBehaviourSetup = ({ showPreviewPage, setShowPreviewPage }) => {
  const handleCheckChange = (value) => {
    setShowPreviewPage(value);
  };

  return (
    <Content>
      <SubcategoryContent>
        <SubcategoryTitleWrapper
          icon={<ComputerIcon />}
          text="Links Behaviour"
          id={"links behaviour"}
          colorType={"faded-dark"}
        />
      </SubcategoryContent>

      <SubcategoryContent>
        <Line>
          <RadioGroup key={1} onClick={(e) => handleCheckChange(false)}>
            <input
              type="radio"
              checked={showPreviewPage !== true}
              onChange={(e) => handleCheckChange(false)}
            />

            <span>Open Automatically</span>
          </RadioGroup>

          <RadioGroup key={2} onClick={(e) => handleCheckChange(true)}>
            <input
              type="radio"
              checked={showPreviewPage === true}
              onChange={(e) => handleCheckChange(true)}
            />

            <span>Show Preview Page</span>
          </RadioGroup>
        </Line>

        {showPreviewPage === true ? (
          <>
            <InfoText>
              Displays a preview before redirecting to the app, store or
              fallback.
            </InfoText>
          </>
        ) : (
          <>
            <InfoText>
              Skips the preview and tries to open the app or store directly. May
              be less accurate, but faster—ideal for guiding users to install
              apps with fewer steps.
            </InfoText>
          </>
        )}
      </SubcategoryContent>
    </Content>
  );
};

export default LinkBehaviourSetup;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
const Line = styled.div`
  margin-top: 10px;
  display: flex;
  align-items: center;
  gap: 15px;
`;
const SubcategoryContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding: 0 40px;
`;

const RadioGroup = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  cursor: pointer;

  span {
    color: ${lightThemeColors.darkColor};
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    text-align: left;
  }

  input {
    height: 15px;
    width: 15px;
  }
`;

const Title = styled.h1`
  color: ${lightThemeColors.darkColorFaded};
  font-size: 20px;
  font-weight: 500;
  line-height: 30px;
  text-align: left;
`;

const ColumnGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  width: 100%;
`;
const PlaceHolderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${lightThemeColors.menuBackground};
  min-width: 400px;
  min-height: 170px;
`;

const InfoText = styled.p`
  color: ${lightThemeColors.inputSubtitleColor};
  margin-top: 15px;
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  text-align: left;
  max-width: 500px;
`;
